import React, { Component } from 'react';
import Chart from "react-apexcharts";
import { postDashboardForm } from '../api/apiClient'
import { Circles } from 'react-loader-spinner'
import ExcelExport from '../ExcelExport/ExcelExport';
import { ROCELL_COLORS, OTA_CHART_COLORS } from '../theme/rocellTheme';
import { buildGroupedBarChartOptions, formatTimeSlotLabel, getBarChartHeight } from '../theme/chartOptions';

export class Chart1 extends Component {
    constructor() {
        super()
        this.state = {
            options: buildGroupedBarChartOptions([], { colors: OTA_CHART_COLORS }),
            chartHeight: getBarChartHeight(0),
            series: [],
            isLoaded: false,
            filterDate: '',
            non_allocated_shipments : [],
            all_shipments : []
        };
        this.componentDidMount = this.componentDidMount.bind(this)
        this.filterChnage = this.filterChnage.bind(this)
        this.updateChart = this.updateChart.bind(this)
    }

    updateState(name, data) {
        const newSeries = {
            name: name,
            data: data
        };

        this.setState((prevState) => ({
            series: [...prevState.series, newSeries]
        }));
    }

    updateLoader(stateValue) {
        if (this.state.isLoaded === true) {
            this.setState({ isLoaded: false })
        } else {
            this.setState({ isLoaded: stateValue })
        }
    }

    updateCategories(newCategories) {
        const chartHeight = getBarChartHeight(newCategories.length);
        this.setState((prevState) => ({
            chartHeight,
            options: buildGroupedBarChartOptions(newCategories, prevState.options),
        }));
    }

    filterChnage(event) {
        console.log(event.target.value)
        this.setState({ filterDate: event.target.value })
    }

    getData(formData) {
        const API_URL = process.env.REACT_APP_API_URL
        const dataUrl = API_URL + "/Bi_dashboard_ota"

        const time_slot = [];
        const arranged_count = [];
        const not_arranged_count = [];

        postDashboardForm(dataUrl, formData).then((response) => {
            if (response.data.success) {
                // API may return an array or an object keyed by interval id
                const rawReportData = response.data.data.report_data;
                const reportData = Array.isArray(rawReportData)
                    ? rawReportData.slice()
                    : Object.values(rawReportData || {});

                // Normalize "12.30 PM" → "12:30 PM" then convert to minutes since midnight
                const parseTimeToMinutes = (value) => {
                    const raw = String(value || '').trim().replace(/\./g, ':');
                    const match = raw.match(/(\d{1,2}):(\d{2})\s*([AaPp][Mm]?)/);
                    if (!match) {
                        return Number.MAX_SAFE_INTEGER;
                    }
                    let hours = parseInt(match[1], 10) % 12;
                    const minutes = parseInt(match[2], 10);
                    if (match[3].toUpperCase().indexOf('P') === 0) {
                        hours += 12;
                    }
                    return hours * 60 + minutes;
                };

                reportData.sort((a, b) => {
                    const startDiff = parseTimeToMinutes(a.time_slot && a.time_slot[0])
                        - parseTimeToMinutes(b.time_slot && b.time_slot[0]);
                    if (startDiff !== 0) {
                        return startDiff;
                    }
                    return parseTimeToMinutes(a.time_slot && a.time_slot[1])
                        - parseTimeToMinutes(b.time_slot && b.time_slot[1]);
                });

                reportData.forEach(item => {
                    const timeSlotStart = item.time_slot[0];
                    const timeSlotEnd = item.time_slot[1];
                    const formattedTimeSlot = formatTimeSlotLabel(timeSlotStart, timeSlotEnd);
                    time_slot.push(formattedTimeSlot);
                    arranged_count.push(item.arranged_count);
                    not_arranged_count.push(item.not_arranged_count);

                });
                const non_allocated_records = response.data.data.non_allocated_shipments;
                const all_shipments = response.data.data.all_shipments;
                this.setState({non_allocated_shipments:non_allocated_records})
                this.setState({all_shipments:all_shipments})
                this.setState({ series: [] })
                this.setState({
                    chartHeight: getBarChartHeight(time_slot.length),
                    options: buildGroupedBarChartOptions(time_slot, { colors: OTA_CHART_COLORS }),
                })
                this.updateState("Arranged", arranged_count)
                this.updateState("Not arranged", not_arranged_count)
                this.updateLoader(true)
            } else {
                console.log("No data returned from API")
                this.updateLoader(true)
            }
        }).catch(function (error) {
            console.log(error);
        });
    }

    updateChart() {
        const newDate = this.state.filterDate;
        const formData = new FormData();
        formData.append('filter_date', newDate);
        this.setState({ isLoaded: false })
        this.getData(formData);
    }

    componentDidMount() {
        const formData = new FormData();
        var currentDate = new Date();
        var currentDate = new Date(currentDate.getTime() - 86400000);
        var formattedDate = currentDate.toISOString().split('T')[0];
        formData.append('filter_date', formattedDate);
        this.setState({ filterDate: formattedDate })
        this.getData(formData);
    }

    render() {
        return (
            <div className='card bi-chart-card'>
                <div className='card-header border-0'>
                    <div className='row align-items-center'>
                        <div className='col-lg-5'>
                            <p className='card-title mb-0'>
                                <span className='card-label fw-bold'>
                                    On Time Arrangement
                                    <span className='bi-date-muted d-block mt-1'>{this.state.filterDate}</span>
                                </span>
                            </p>
                        </div>
                        <div className='col-lg-7 bi-chart-actions mt-3 mt-lg-0'>
                            <button
                                type='button'
                                className='btn btn-sm btn-light-primary'
                                data-kt-menu-trigger='click'
                                data-kt-menu-placement='bottom-end'
                                data-kt-menu-flip='top-end'>
                                <i className='fas fa-filter me-1'></i> Filter
                            </button>
                            <ExcelExport data={this.state.all_shipments} fileName="On Time Arrangement Export" />

                            <div className='menu menu-sub menu-sub-dropdown w-250px w-md-300px' data-kt-menu='true'>
                                <div className='px-7 py-5'>
                                    <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
                                </div>

                                <div className='separator border-gray-200'></div>

                                <div className='px-7 py-5'>
                                    <div className='mb-10'>
                                        <label className='form-label fw-bold'>Filter Date:</label>
                                        <div>
                                            <input type="Date" name='date' value={this.state.filterDate} className='form-control' onChange={this.filterChnage} />
                                        </div>
                                    </div>

                                    <div className='d-flex justify-content-end'>
                                        <button
                                            type='reset'
                                            className='btn btn-sm btn-white btn-active-light-primary me-2'
                                            data-kt-menu-dismiss='true'>
                                            Reset
                                        </button>

                                        <button type='submit' className='btn btn-sm btn-primary' data-kt-menu-dismiss='true' onClick={this.updateChart}>
                                            Apply
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='card-body'>
                    <div className='row g-4'>
                        <div className='col-12'>
                            <div className={`bi-chart-area bi-chart-area--bar${!this.state.isLoaded ? ' bi-chart-area--loading' : ''}`}>
                                {!this.state.isLoaded ? (
                                    <Circles
                                        height="80"
                                        width="80"
                                        color={ROCELL_COLORS.accent}
                                        ariaLabel="circles-loading"
                                        visible={true}
                                    />
                                ) : (
                                    <Chart
                                        options={this.state.options}
                                        series={this.state.series}
                                        type="bar"
                                        width="100%"
                                        height={this.state.chartHeight}
                                    />
                                )}
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className='bi-table-scroll'>
                                <table className='table table-bordered bi-data-table'>
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Time Interval</th>
                                            <th>Shipment #</th>
                                            <th>Gate Pass Print Time</th>
                                            <th>Vehicle #</th>
                                            <th>OTA / Non OTA</th>
                                            <th>Trip Type</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.all_shipments.map((record,index) => (
                                        <tr key={index}>
                                            <td>{record.shipment_date}</td>
                                            <td>{record.time_interval_id}</td>
                                            <td>{record.shipment_number}</td>
                                            <td>{record.gate_pass_last_print_time}</td>
                                            <td>{record.vehicle_number == null ? "N/A" : record.vehicle_number}</td>
                                            <td>{record.status}</td>
                                            <td>{record.tms_shp_trip_mode}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}